export const HOLIDAY_LIST_SUCCESS = 'HOLIDAY_LIST_SUCCESS';
export const HOLIDAY_LIST_FAIL = 'HOLIDAY_LIST_FAIL';
export const EDIT_HOLIDAY_SUCCESS = 'EDIT_HOLIDAY_SUCCESS';
export const EDIT_HOLIDAY_FAIL = 'EDIT_HOLIDAY_FAIL';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
